import type { PaypalConfig } from '#types/config/components/paypal'
import type { RecursivePartial } from '#types/utils'

export default {
  style: {
    height: 48,
    shape: 'rect',
    borderRadius: 2,
    color: 'white',
    label: 'paypal'
  }
} satisfies RecursivePartial<PaypalConfig['button']>
